import { BodyText, TableCell, TableRow } from "@/components/ui";
import { formatDateTime } from "@/lib/time";
import {
  TASK_TYPE_LABELS,
  type TaskListItemType,
} from "../network/useTaskList";

export const TaskListRow = ({
  identifier,
  type,
  patientName,
  patientState,
  message,
  taskDueTimestamp,
  actionButtons,
}: {
  identifier: string;
  type: TaskListItemType;
  patientName: string;
  patientState?: string;
  message: string;
  taskDueTimestamp: string;
  actionButtons: React.ReactNode[];
}) => {
  return (
    <TableRow key={`${type}-${identifier}`}>
      <TableCell className="max-w-48">
        <BodyText size="sm">{TASK_TYPE_LABELS[type]}</BodyText>
      </TableCell>
      <TableCell className="max-w-48">
        <BodyText size="sm">{patientName}</BodyText>
      </TableCell>
      <TableCell className="min-w-48">
        <BodyText size="sm">{patientState || "-"}</BodyText>
      </TableCell>
      <TableCell>
        <BodyText size="sm">{message}</BodyText>
      </TableCell>
      <TableCell>
        <BodyText size="sm">{formatDateTime(taskDueTimestamp)}</BodyText>
      </TableCell>
      <TableCell className="flex gap-2 items-center">{actionButtons}</TableCell>
    </TableRow>
  );
};
